var map = {
	"./angbao-bonus-cny.webp": 2517,
	"./angbao-bonus-dewali.webp": 2518,
	"./angbao-bonus-mooncake.webp": 2519,
	"./angbao-bonus-thaipusam.webp": 2520,
	"./angbao-bonus.webp": 2521,
	"./anni-lucky-draw.webp": 2522,
	"./cny-angbao-bonus.webp": 2523,
	"./cny-lucky-draw.webp": 2524,
	"./cny-promo.webp": 2525,
	"./dewali-promo.webp": 2526,
	"./dongzhi-angbao-bonus.webp": 2527,
	"./fifa-logo.webp": 2528,
	"./fifa-prediction.webp": 2529,
	"./fifa-qna.webp": 2530,
	"./uefa-predic.webp": 2531,
	"./welcome-cny-bonus.webp": 2532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2516;